export const TranslationUtils = {
  EDIT_KEY: 'COMMON.EDIT',
  NEW_KEY: 'COMMON.NEW',
  WARNING_PREVIOUS_STEP_KEY: 'COMMON.MBC_DETAILS.METER_TYPE.WARNING_CONFIGURE_PREVIOUS_STEP',
  WARNING_CHOOSE_SMALLER_IMAGE_KEY: 'COMMON.MBC_DETAILS.METER_TYPE.WARNING_CHOOSE_SMALLER_IMAGE',
  WARNING_ERROR_OCCURRED_KEY: 'COMMON.ERROR_OCCURRED'
 };
